// extracted by mini-css-extract-plugin
export default {"CallTollFreeTitle":"CallTollFree_CallTollFreeTitle__l1adc","CallTollFreeBottom":"CallTollFree_CallTollFreeBottom__q4Jrj","CallTollFreePhone":"CallTollFree_CallTollFreePhone__q+8I1"};